"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeBicyclesWidget = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var uuid_1 = require("uuid");
var React = require("react");
var journey_services_1 = require("@athena-portal/journey-services");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../../Types");
var ConfirmModal_1 = require("../../../../components/modals/ConfirmModal");
var AnnualHomeBicylecInfo_1 = require("./AnnualHomeBicylecInfo");
var BicycleInfoModal_1 = require("./BicycleInfoModal");
var AnnualHomeBicycleModal_1 = require("./AnnualHomeBicycleModal");
var journey_model_1 = require("@athena-portal/journey-model");
var AnnualHomeBicyclesWidget = exports.AnnualHomeBicyclesWidget = /** @class */ (function (_super) {
    __extends(AnnualHomeBicyclesWidget, _super);
    function AnnualHomeBicyclesWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isInfoModalOpen: false,
            isAddItemModalOpen: false,
            isRemovalModalOpen: false,
            tieredUnderwritingResult: _this.props.interaction.tieredUnderwritingResult
        };
        _this.toggleInfoModal = _this.toggleInfoModal.bind(_this);
        _this.toggleAddItemModal = _this.toggleAddItemModal.bind(_this);
        _this.toggleRemovalModal = _this.toggleRemovalModal.bind(_this);
        _this.removeBicycleEvent = _this.removeBicycleEvent.bind(_this);
        _this.addItem = _this.addItem.bind(_this);
        _this.editItem = _this.editItem.bind(_this);
        _this.removeItem = _this.removeItem.bind(_this);
        return _this;
    }
    AnnualHomeBicyclesWidget.prototype.render = function () {
        var bicycles = this.props.interaction.bicycles;
        var filteredBicycles = bicycles && this.props.interaction.bicycles
            .filter(function (bicycle) { return bicycle.flowValuable; });
        var hasBicycles = filteredBicycles && filteredBicycles.length > 0;
        var backgroundClass;
        var widgetIcon;
        var wording;
        if (hasBicycles) {
            backgroundClass = "fixed-addon-background-selected";
            widgetIcon = React.createElement("img", { className: "fixed-addon-icon float-left", src: "/".concat(services_1.resourcesHelper.THEME, "/img/fixed-addon-selected-tick.png"), alt: "addon selected icon" });
            wording = React.createElement("p", { className: "mt-0 mb-0" }, "Covered in and out from your home");
        }
        else {
            backgroundClass = "fixed-addon-background";
            widgetIcon = React.createElement("img", { className: "fixed-addon-icon float-left", src: "/".concat(services_1.resourcesHelper.THEME, "/img/bicycle-icon.png"), alt: "addon icon" });
            wording = React.createElement("p", { className: "mt-0 mb-0" },
                "Add bicycles that are worth over ",
                React.createElement("span", { className: "font-weight-700" }, "\u00A3350"),
                " each to be covered in and out of your home");
        }
        return (React.createElement("div", { className: "".concat(backgroundClass, " quote row mt-2 pb-0 position-relative") },
            React.createElement("div", { className: "col p-0 d-flex align-items-start fixed-addon-item" },
                widgetIcon,
                React.createElement("div", { className: "w-100" },
                    React.createElement("div", { className: "heading-info" },
                        React.createElement("p", { className: "font-weight-bold mt-0 mb-0 heading" }, "Bicycles"),
                        React.createElement("div", { className: "fixed-addon-info cursor-pointer info-button", onClick: this.toggleInfoModal })),
                    wording,
                    this.renderAddedItems(filteredBicycles),
                    !this.itemLimitReached() && this.renderAddLink(),
                    React.createElement(BicycleInfoModal_1.default, { closeModal: this.toggleInfoModal, isOpen: this.state.isInfoModalOpen }),
                    this.renderAddItemModal(),
                    this.renderItemRemovalModal()))));
    };
    AnnualHomeBicyclesWidget.prototype.renderAddLink = function () {
        return (React.createElement("p", { className: "mt-0 mb-0 font-weight-bold margin-top-32" },
            React.createElement("span", { className: "clickable-area", onClick: this.toggleAddItemModal },
                "+",
                ' '),
            React.createElement("span", { className: "blue-link-underline clickable-area", onClick: this.toggleAddItemModal }, "Add bicycle")));
    };
    AnnualHomeBicyclesWidget.prototype.renderAddedItems = function (bicycles) {
        return (React.createElement(AnnualHomeBicylecInfo_1.default, { bicycles: bicycles, editBicycle: this.editItem, removeBicycle: this.removeBicycleEvent }));
    };
    AnnualHomeBicyclesWidget.prototype.renderAddItemModal = function () {
        var item;
        var title;
        if (this.state.editItem) {
            item = this.state.editItem;
            title = "Edit bicycle";
        }
        else {
            item = new services_1.AnnualHomeValuableItem();
            item.valuableItemId = (0, uuid_1.v4)();
            title = "Add bicycle";
        }
        return (React.createElement(React.Fragment, null, this.state.isAddItemModalOpen && React.createElement(AnnualHomeBicycleModal_1.default, { title: title, item: item, interaction: this.props.interaction, closeModal: this.toggleAddItemModal, onConfirm: this.addItem, addPhotoEnabled: this.getSetting("addPhotoEnabled", true) })));
    };
    AnnualHomeBicyclesWidget.prototype.renderItemRemovalModal = function () {
        return (React.createElement(ConfirmModal_1.default, { show: this.state.isRemovalModalOpen, onHide: this.toggleRemovalModal, onConfirm: this.removeItem, confirmButtonText: "Yes, please" },
            React.createElement("div", { className: "fs-20 font-weight-medium font-family-display" }, "Are you sure you want to remove this item?")));
    };
    AnnualHomeBicyclesWidget.prototype.toggleInfoModal = function () {
        this.setState({
            isInfoModalOpen: !this.state.isInfoModalOpen
        });
    };
    AnnualHomeBicyclesWidget.prototype.toggleAddItemModal = function () {
        var _a;
        var newValue = !this.state.isAddItemModalOpen;
        this.setState({
            isAddItemModalOpen: newValue
        });
        if (!newValue) {
            if (((_a = this.state.editItem) === null || _a === void 0 ? void 0 : _a.coverLocation) === services_1.ValuableItemCoverLocation.HOME) {
                this.remove(this.state.editItem);
            }
            this.setState({
                editItem: undefined
            });
        }
    };
    AnnualHomeBicyclesWidget.prototype.toggleRemovalModal = function () {
        this.setState({
            isRemovalModalOpen: !this.state.isRemovalModalOpen
        });
    };
    AnnualHomeBicyclesWidget.prototype.removeBicycleEvent = function (bicyle) {
        this.setState({
            removeItem: bicyle
        });
        this.toggleRemovalModal();
    };
    AnnualHomeBicyclesWidget.prototype.addItem = function (bicycle) {
        var bicycles = this.props.interaction.bicycles ? this.props.interaction.bicycles : [];
        if (bicycles && bicycles.filter(function (innerItem) { return innerItem.valuableItemId === bicycle.valuableItemId; }).length === 0) {
            bicycles.push(bicycle);
        }
        journey_services_1.ObjectManipulator.setField("bicycles", this.props.interaction, bicycles);
        this.executeEvent("change");
        this.changelogRecorder.recordPage("change", this.props, "bicycles");
        this.setState({
            isAddItemModalOpen: false,
            editItem: undefined
        });
    };
    AnnualHomeBicyclesWidget.prototype.editItem = function (bicycle) {
        this.setState({
            editItem: bicycle
        });
        this.toggleAddItemModal();
    };
    AnnualHomeBicyclesWidget.prototype.removeItem = function () {
        if (this.state.removeItem) {
            this.remove(this.state.removeItem);
            this.toggleRemovalModal();
            this.setState({
                removeItem: undefined
            });
        }
    };
    AnnualHomeBicyclesWidget.prototype.remove = function (item) {
        var bicycle = item;
        var bicycles = this.props.interaction.bicycles ? this.props.interaction.bicycles : [];
        var index = bicycles.map(function (i) { return i.valuableItemId; }).indexOf(bicycle.valuableItemId);
        bicycles.splice(index, 1);
        journey_services_1.ObjectManipulator.setField("bicycles", this.props.interaction, bicycles);
        this.executeEvent("change");
        this.changelogRecorder.recordPage("change", this.props, "bicycles");
    };
    AnnualHomeBicyclesWidget.prototype.itemLimitReached = function () {
        return this.props.interaction.bicycles && this.props.interaction.bicycles.length >= 16;
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], AnnualHomeBicyclesWidget.prototype, "changelogRecorder", void 0);
    AnnualHomeBicyclesWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "addPhotoEnabled", type: journey_model_1.TypeDescriptions.Boolean },
        ]),
        __metadata("design:paramtypes", [Object])
    ], AnnualHomeBicyclesWidget);
    return AnnualHomeBicyclesWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=AnnualHomeBicyclesWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/valuableItemWidget/AnnualHomeBicyclesWidget.js
// module id = 3695
// module chunks = 0